import React, { useState } from 'react';
import { Box, Typography, Collapse } from '@mui/material';
import { ExpandMore, ChevronRight } from '@mui/icons-material';
import { vortxTypography } from '@vortx/shared-ui';
import { COLORS } from '../results/ResultsDesignTokens';

const accentColor = '#9b59b6';

const SectionGroup = ({ section, activePage, onPageSelect }) => {
    const [expanded, setExpanded] = useState(true);
    const hasActivePage = section.pages.some(p => p.id === activePage);

    return (
        <Box sx={{ mb: 1 }}>
            <Box
                onClick={() => setExpanded(!expanded)}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                    px: 1,
                    py: 0.5,
                    cursor: 'pointer',
                    borderRadius: '4px',
                    '&:hover': { backgroundColor: `${accentColor}10` },
                }}
            >
                {expanded ? (
                    <ExpandMore sx={{ fontSize: 14, color: accentColor }} />
                ) : (
                    <ChevronRight sx={{ fontSize: 14, color: COLORS.text.muted }} />
                )}
                <Typography sx={{
                    fontFamily: vortxTypography.mono,
                    fontSize: '0.7rem',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: '0.08em',
                    color: hasActivePage ? accentColor : COLORS.text.secondary,
                }}>
                    {section.title}
                </Typography>
            </Box>
            <Collapse in={expanded}>
                <Box sx={{ pl: 1 }}>
                    {section.pages.map((page) => (
                        <Box
                            key={page.id}
                            onClick={() => onPageSelect(page.id)}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                px: 1,
                                py: 0.4,
                                cursor: 'pointer',
                                borderLeft: '2px solid',
                                borderLeftColor: activePage === page.id ? accentColor : `${accentColor}25`,
                                background: activePage === page.id ? `${accentColor}15` : 'transparent',
                                borderRadius: '0 4px 4px 0',
                                transition: 'all 0.15s ease',
                                '&:hover': {
                                    borderLeftColor: accentColor,
                                    background: `${accentColor}10`,
                                },
                            }}
                        >
                            <Typography sx={{
                                fontFamily: vortxTypography.mono,
                                fontSize: '0.75rem',
                                color: activePage === page.id ? COLORS.text.primary : COLORS.text.secondary,
                                fontWeight: activePage === page.id ? 600 : 400,
                                transition: 'all 0.15s ease',
                            }}>
                                {page.title}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Collapse>
        </Box>
    );
};

const WikiToc = ({ sections, activePage, onPageSelect }) => (
    <Box sx={{
        width: 220,
        minWidth: 220,
        borderRight: `1px solid ${accentColor}15`,
        py: 2,
        overflowY: 'auto',
    }}>
        <Typography sx={{
            fontFamily: vortxTypography.mono,
            fontSize: '0.65rem',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.12em',
            color: COLORS.text.muted,
            px: 1.5,
            mb: 1.5,
        }}>
            Contents
        </Typography>
        {sections.map((section) => (
            <SectionGroup
                key={section.id}
                section={section}
                activePage={activePage}
                onPageSelect={onPageSelect}
            />
        ))}
    </Box>
);

export default WikiToc;
